import CitySEOHead from "@/components/feature/CitySEOHead";
import DesMoinesHeroSection from "./components/HeroSection";
import DesMoinesStickyNav from "./components/StickyNav";
import DesMoinesProcessingTimeSection from "./components/ProcessingTimeSection";
import DesMoinesServicesSection from "./components/ServicesSection";
import DesMoinesLocalAreaSection from "./components/LocalAreaSection";
import DesMoinesTestimonialsSection from "./components/TestimonialsSection";
import DesMoinesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DesMoinesComparisonSection from "./components/ComparisonSection";
import DesMoinesMistakesSection from "./components/MistakesSection";
import DesMoinesHowItWorksSection from "./components/HowItWorksSection";
import DesMoinesFAQSection, { faqs } from "./components/FAQSection";
import DesMoinesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DesMoinesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DesMoinesPage() {
  return (
    <>
      <CitySEOHead
        city="Des Moines"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/des-moines"
        title="Emergency Passport Des Moines, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Des Moines, IA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Polk County and central Iowa travelers."
        geoPlacename="Des Moines, Iowa"
        geoPosition="41.5868;-93.6250"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
        keywords="expedited passport, emergency passport, Des Moines passport, same day passport Des Moines, fast passport Iowa"
      />
      <div className="font-sans">
        <DesMoinesHeroSection />
        <DesMoinesStickyNav />
        <DesMoinesProcessingTimeSection />
        <DesMoinesLocalAreaSection />
        <DesMoinesServicesSection />
        <DesMoinesTestimonialsSection />
        <DesMoinesAcceptanceFacilitiesSection />
        <DesMoinesComparisonSection />
        <DesMoinesMistakesSection />
        <DesMoinesHowItWorksSection />
        <DesMoinesFAQSection />
        <DesMoinesHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/des-moines" state="IA" />
        <DesMoinesFinalCTA />
      </div>
    </>
  );
}